export default __webpack_public_path__ + "static/media/simdustry-logo.4af839ea.png";